import ListDrivingLicenceApply from "./ListDrivingLicenceApply";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDrivingData } from "../../../../../store/Api";
import { setAppError } from "./../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";

export default function DrivingLicenceApply() {
  const drivingLicData = useSelector((state) => state.drivingData);
  const dispatch = useDispatch();

  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectVisaProvider, setSelectVisaProvider] = useState("");
  const [filter, setFiltered] = React.useState([]);

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  const getData = async () => {
    try {
      const reqObj = {
        visa_provider: selectVisaProvider,
        client: selectedStatus,
      };
      const response = await nodeinstance.post(
        `/drivingLicense/getLicenseDatabyfilter`,
        reqObj,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setFiltered(response.data.data);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };

  useEffect(() => {
    // dispatch(getDrivingData(token));
    getData();
  }, [selectedStatus, selectVisaProvider]);

  const updateData = () => {
    // dispatch(getDrivingData(token));
    getData();
  };

  return (
    <>
      <ListDrivingLicenceApply
        titles={[
          "SR.NO.",
          "employee ID",
          "employee NAME",
          "ACTUAL PROFESSION",
          "IQAMA PROFESSION",
          "VISA PROVIDER",
          "SPONSOR",
          "CLIENT NAME",
          "IQAMA NUMBER",
          "LICENCE TYPE",
          "DRIVING LICENCE APPLY DATE",
          "DRIVING LICENCE ISSUE DATE",
          "DRIVING LICENCE EXPIRY DATE",
          "DRIVING LICENCE VALID DAYS",
          "checkBox",
        ]}
        list={filter}
        loading={loading}
        token={token}
        callBack={updateData}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        selectVisaProvider={selectVisaProvider}
        setSelectVisaProvider={setSelectVisaProvider}
        filter={filter}
        setFiltered={setFiltered}
      />
    </>
  );
}
